<template>
  <!-- 网点管理 -->
  <div class="page-container">
    <div class="page-top-tool">
      <!-- <el-button v-if="userPrower == '1'" type="success" icon="el-icon-plus" size="mini" @click="toAddStorePage">新增名片</el-button> -->
      <div class="right-search">
        <span style="margin-left: 20px;">用户编号：</span>
        <el-input v-model="user_no" clearable placeholder="请输入用户编号" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <span style="margin-left: 20px;">姓名：</span>
        <el-input v-model="name" clearable placeholder="请输入个人姓名" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <span style="margin-left: 20px;">手机号：</span>
        <el-input v-model="phone" clearable placeholder="请输入手机号" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <el-button type="primary" icon="el-icon-search" size="mini" :disabled="loading" style="margin-left: 20px;" @click="onSearch">搜索</el-button>
      </div>
    </div>
    <div class="filter-btns">
        <el-radio-group v-model="status" size="mini" @input="getData">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="3">待审核</el-radio-button>
          <el-radio-button label="1">正常</el-radio-button>
          <el-radio-button label="-1">未开通</el-radio-button>
          <el-radio-button label="2">停用</el-radio-button>
          <el-radio-button label="-2">已过期</el-radio-button>
        </el-radio-group>
      </div>
    <el-table
      :data="tableData"
      v-loading="loading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      style="width: 100%; font-size: 12px; margin: 20px 0px;"
      :header-cell-style="tableHeaderColor"
    >
    <el-table-column prop="user_no" label="用户编号" width=""></el-table-column>
    <el-table-column prop="name" label="姓名" width=""></el-table-column>
    <el-table-column label="头像" width="">
      <template slot-scope="scope">
        <img :src="`${baseurl}/${scope.row.photo}`" style="width: 50px; height: 50px; border: 1px solid #eee; margin-right: 10px;" v-if="scope.row.photo" alt="">
      </template>
    </el-table-column>
      <!-- <el-table-column label="性别" width="">
        <template slot-scope="scope">
          <span v-if="scope.row.sex == '1'">男</span>
          <span v-else-if="scope.row.sex == '2'">女</span>
          <span v-else>未知</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="company_name" label="公司名称" width=""></el-table-column> -->
      <!-- <el-table-column prop="job_title" label="职务" width="100"></el-table-column> -->
      <el-table-column prop="phone" label="手机号" width=""></el-table-column>
      <!-- <el-table-column prop="telephone" label="手机号2" width=""></el-table-column> -->
      <!-- <el-table-column prop="email" label="邮箱" width=""></el-table-column> -->
       <el-table-column label="版本" width="">
        <template slot-scope="scope">
          <span v-if="scope.row.card_version == '-1'">永久版</span>
          <span v-else-if="scope.row.card_version == '1'">月会员</span>
          <span v-else-if="scope.row.card_version == '2'">季会员</span>
          <span v-else-if="scope.row.card_version == '3'">年会员</span>
        </template>
      </el-table-column>
      <el-table-column label="上级管理" width="100">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>上级编号：{{ scope.row.p_invite_code }}</p>
            <div slot="reference" class="name-wrapper">
              <el-link type="primary" v-if="scope.row.p_invite_code && scope.row.p_invite_code != ''">有上级</el-link>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="账号状态" width="">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == '-1'" type="warning" size="mini">未开通</el-tag>
          <el-tag v-else-if="scope.row.status == '1'" type="success" size="mini">正常</el-tag>
          <el-tag v-else-if="scope.row.status == '2'" type="info" size="mini">停用</el-tag>
          <el-tag v-else-if="scope.row.status == '3'" type="danger" size="mini">待审核</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="reg_date" label="注册时间" width=""></el-table-column>
      <el-table-column prop="pay_date" label="交费时间" width=""></el-table-column>
      <el-table-column label="到期时间" width="">
        <template slot-scope="scope">
            <span v-if="scope.row.end_date < getCurrentDate()" style="color: red;">{{ scope.row.end_date }}</span>
            <span v-else>{{ scope.row.end_date }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="userPrower == '1'" label="操作" width="240">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == '-1'" type="text" size="mini" @click="onOpenCard(scope)">开通</el-button>
          <el-button v-else-if="scope.row.status == '1' || scope.row.status == '2'" type="text" size="mini" @click="onUpdateState(scope)">
            <span v-if="scope.row.status == '1'">停用</span>
            <span v-else-if="scope.row.status == '2'">启用</span>
          </el-button>
          <el-button v-if="scope.row.status == '1'" type="text" size="mini" @click="onUpgrade(scope)">续费/升级</el-button>
          <el-button v-if="scope.row.status != '3'" type="text" size="mini" @click="showDetail(scope.row)">查看详情</el-button>
          <el-button v-if="scope.row.status == '3'" type="text" size="mini" @click="showDetail(scope.row)">审核</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
    :current-page.sync="currentPage"
    :page-size="pageSize"
    hide-on-single-page
    background
    layout="total, prev, pager, next"
    :total="total"
    @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 开通名片弹框 -->
    <el-dialog title="开通名片" :visible.sync="dialogOpencardVisible" @close="opencardDialogClose" :close-on-click-modal="false" :show-close="true" style="margin-top: -50px;">
        <div class="open-card-dialog" style="margin-top: -20px;">
            <div class="open-card-dialog-item">用户手机号：{{ this.activeObj.phone }}</div>
            <div class="open-card-dialog-item">
                开通版本：
                <el-radio-group v-model="card_version">
                    <el-radio border :label="1">月会员</el-radio>
                    <el-radio border :label="-1">永久版</el-radio>
                </el-radio-group>
            </div>
        </div>
        <div class="dialog-btn">
            <el-button @click="opencardDialogClose">取消</el-button>
            <el-button type="primary" :disabled="!card_version || card_version == ''" @click="handleOpenUserCards">开通</el-button>
        </div>
    </el-dialog>
    <!-- 续费升级弹框 -->
     <el-dialog title="续费升级" :visible.sync="dialogUpgradeVisible" @close="upgradeDialogClose" :close-on-click-modal="false" :show-close="true" style="margin-top: -50px;">
        <div class="open-card-dialog" style="margin-top: -20px;">
            <div class="open-card-dialog-item">用户姓名：{{ this.activeObj.name }}</div>
            <div class="open-card-dialog-item">手机号：{{ this.activeObj.phone }}</div>
            <div class="open-card-dialog-item">
                续费/升级：
                <el-radio-group v-model="up_type">
                    <el-radio border :label="1">续费月会员</el-radio>
                    <el-radio border :label="-1">永久版</el-radio>
                </el-radio-group>
            </div>
            <div v-if="up_type == '1'" class="open-card-dialog-item">
                续费时长：
                <el-input-number v-model="upNum" :min="1" size="small" label="续费时长"></el-input-number> 个月
            </div>
        </div>
        <div class="dialog-btn">
            <el-button @click="upgradeDialogClose">取消</el-button>
            <el-button type="primary" :disabled="!up_type || up_type == ''" @click="handleUpgrade">{{ up_type == '1' ? '续费' : '升级' }}</el-button>
        </div>
    </el-dialog>

    <!-- 查看详情 -->
    <el-dialog title="名片详情" :visible.sync="dialogDetailVisible" @close="imageDialogClose" :show-close="true" style="margin-top: -50px;">
      <div class="active-detail" style="text-align: center;margin-top: -20px;">
        <el-descriptions class="margin-top" :column="2" border>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-xingming"></i>
                姓名
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.name }}
              <el-link v-if="activeObj.name && activeObj.status == '3'" @click="onRemoveCardInfo({name:''},'name')" type="danger" style="margin-left: 10px;">
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-touxiang"></i>
                头像
              </div>
            </template>
            <div style="width: 150px;">
              <el-tooltip placement="top">
                <img :src="`${baseurl}/${activeObj.photo}`" style="width: 50px; height: 50px; border: 1px solid #eee; margin-right: 10px;" v-if="activeObj.photo" alt="">
                <div slot="content">
                  <img v-if="activeObj.photo" :src="`${baseurl}/${activeObj.photo}`" style="width: 300px;" alt="">
                </div>
              </el-tooltip>
              <el-link v-if="activeObj.photo && activeObj.status == '3'" type="danger" @click="onRemoveImage(activeObj.photo,'photo')">删除</el-link>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-gongsimingcheng"></i>
                公司名称
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.company }}
              <el-link v-if="activeObj.company && activeObj.status == '3'" @click="onRemoveCardInfo({company:''},'company')" type="danger" style="margin-left: 10px;">
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-zhiwu"></i>
                职务
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.job }}
              <el-link v-if="activeObj.job && activeObj.status == '3'" @click="onRemoveCardInfo({job:''},'job')" type="danger" style="margin-left: 10px;">
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-shoujihao"></i>
                手机号
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.phone }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-youxiang"></i>
                邮箱
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.email }}
              <el-link v-if="activeObj.email && activeObj.status == '3'" @click="onRemoveCardInfo({email:''},'email')" type="danger" style="margin-left: 10px;">
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-gongsidizhi"></i>
                公司地址
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.address }}
              <el-link v-if="activeObj.address && activeObj.status == '3'" @click="onRemoveCardInfo({address:''},'address')" type="danger" style="margin-left: 10px;">
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-weixinhao"></i>
                微信号
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.weixin }}
              <el-link v-if="activeObj.weixin && activeObj.status == '3'" @click="onRemoveCardInfo({weixin:''},'weixin')" type="danger" style="margin-left: 10px;">
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
          </el-descriptions-item>
          <!-- <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-dengji"></i>
                上级代理
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.p_invite_code }}
            </div>
          </el-descriptions-item> -->
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-chuangjianshijian"></i>
                注册时间
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.reg_date }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 120px;">
                <i class="iconfont icon-xiugaishijian"></i>
                开通时间
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.pay_date }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 120px;">
                到期时间
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.end_date }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 120px;">
                分享图片
              </div>
            </template>
            <div style="width: 150px">
              <el-tooltip placement="top">
                  <img :src="`${baseurl}/${activeObj.share_image}`" style="width: 50px; height: 50px; border: 1px solid #eee; margin-right: 10px;" v-if="activeObj.share_image" alt="">
                  <div slot="content">
                    <img v-if="activeObj.share_image" :src="`${baseurl}/${activeObj.share_image}`" style="width: 300px;" alt="">
                  </div>
              </el-tooltip>
              <el-link v-if="activeObj.share_image && activeObj.status == '3'" type="danger" @click="onRemoveImage(activeObj.share_image,'share_image')">删除</el-link>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 120px;">
                分享标题
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.share_title }}
              <el-link v-if="activeObj.share_title && activeObj.status == '3'" @click="onRemoveCardInfo({share_title:''},'share_title')" type="danger" style="margin-left: 10px;">
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 120px;">
                分享描述
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.share_desc }}
              <el-link v-if="activeObj.share_desc && activeObj.status == '3'" @click="onRemoveCardInfo({share_desc:''},'share_desc')" type="danger" style="margin-left: 10px;">
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-poster"></i>
                名片海报
              </div>
            </template>
            <div style="width: 150px">
              <template v-for="(item,index) of activeObj.bannerimg">
                <div :key="index" style="margin-bottom: 10px;">
                  <el-tooltip placement="top">
                    <span>
                      {{ index + 1 }}. 
                      <img :src="`${baseurl}/${item}`" style="width: 50px; height: 50px; border: 1px solid #eee; margin-right: 10px;" v-if="item" alt="">
                    </span>
                    <div slot="content">
                      <img v-if="item" :src="`${baseurl}/${item}`" style="width: 300px;" alt="">
                    </div>
                  </el-tooltip>
                  <el-link v-if="item && activeObj.status == '3'" type="danger" @click="onBatchRemoveBanner(item, index)">删除</el-link>
                </div>
              </template>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-if="activeObj.status == '3'" class="review-btns">
        <el-button size="small" :loading="newLoading" @click="getNewCardInfo">刷新</el-button>
        <el-button type="warning" size="small" @click="onClearData">清空数据</el-button>
        <el-button type="danger" size="small" @click="imageDialogClose">拒绝通过</el-button>
        <el-button type="success" size="small" @click="onPassReview">审核通过</el-button>
      </div>
      <div v-else class="review-btns">
        <el-button type="warning" size="small" @click="onJoinReview">列入待审</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'StorePage',

  data() {
    return {
      userPrower: '', // 用户权限
      name: '', // 姓名
      company_name: '', // 公司名称
      user_no: '', // 用户编号
      phone: '', // 手机号
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      activeObj: {},
      dialogDetailVisible: false,
      dialogOpencardVisible: false,
      dialogUpgradeVisible: false,
      baseurl: '',
      card_version: '',
      up_type: '',
      upNum: 1,
      status: '',
      newLoading: false
    };
  },

  mounted() {
    this.baseurl = this.$baseUrl
    let userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      this.userPrower = userInfo.prower
    } else {
      this.$http({
        method: 'post',
        url: 'user_exit'
      })
      this.$router.push({
        path: '/login'
      })
    }
    this.getData()
  },

  methods: {
    getData() {
      this.loading = true
      this.$http({
        method: 'post',
        url: `/cards/find?page=${this.currentPage}&pageSize=${this.pageSize}`,
        params: {
          user_no: this.user_no,
          name: this.name,
          phone: this.phone,
          status: this.status
        }
      })
      .then(res => {
        this.loading = false
        if (res.errno == 0) {
          let { data, page, pageSize, count } = res.data
          data.forEach(item => {
            if (item.bannerimg) {
              item.bannerimg = JSON.parse(item.bannerimg)
            }
          })
          
          this.tableData = data
          this.currentPage = page
          this.pageSize = pageSize
          this.total = count
        } else {
          this.$message.error('查询失败')
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('服务端异常，查询失败')
        console.error('查询异常：', err.message);
      })
    },
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      return 'background-color: #F2F2F2;color:#101010;'
    },
    onSearch() {
      this.currentPage = 1
      this.getData()
    },
    toAddStorePage() {
      this.$router.push({
        path: '/addPersonal'
      })
    },
    // 页码改变
    handleCurrentChange(page) {
      this.currentPage = page
      this.getData()
    },
    // 查看名片详情
    showDetail(row) {
      this.activeObj = row
      this.dialogDetailVisible = true
    },
    // 显示开通名片弹框
    onOpenCard({ row, $index }) {
        this.activeObj = row
        this.dialogOpencardVisible = true
    },
    // 开通名片
    handleOpenUserCards() {
        this.$confirm(`确定要开通 ${this.activeObj.phone} 的名片吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.loading = true
            this.$http({
            method: 'post',
            url: '/cards/update',
            params: {
                id: this.activeObj.id,
                status: '1',
                card_version: this.card_version
            }
            })
            .then(res => {
            this.loading = false
            if (res.errno == 0) {
                this.$message.success('操作成功')
                this.opencardDialogClose()
                this.getData()
            } else {
                this.$message.error('操作失败')
            }
            })
            .catch(err => {
            this.loading = false
            this.$message.error('操作异常')
            })
        }).catch(() => {});
    },
    // 显示续费升级弹框
    onUpgrade({ row, $index }) {
        this.activeObj = row
        this.dialogUpgradeVisible = true
    },
    getCurrentDate() {
        let date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}` 
        const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`

        return `${year}/${month}/${day}`
    },
    getEndDate(endDate) {
        let d1 = new Date()
        if (endDate && endDate != '') {
            d1 = new Date(endDate)
        }
        let t1 = d1.getTime()
        let long = 1000 * 60 * 60 * 24 * (30 * this.upNum)
        let t2 = t1 + long
        let d2 = new Date(t2)
        const year = d2.getFullYear()
        const month = d2.getMonth() + 1 >= 10 ? d2.getMonth() + 1 : `0${d2.getMonth() + 1}`
        const day = d2.getDate() >= 10 ? d2.getDate() : `0${d2.getDate()}`
        return `${year}/${month}/${day}`
    },
    // 名片版本升级
    handleUpgrade() {
        let card_version = this.activeObj.card_version
        let endDate = ''
        if (this.up_type == '-1') {
            card_version = '-1'
        } else if (this.up_type == '1') {
            let currentDate = this.getCurrentDate()
            if (currentDate <= this.activeObj.end_date) {
                // 未过期
                endDate = this.getEndDate(this.activeObj.end_date)
            } else {
                // 已过期
                endDate = this.getEndDate()
            }
        }
        this.$confirm(`确定要${this.up_type == '1' ? '续费' : '升级'} ${this.activeObj.phone} 的名片吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.loading = true
            this.$http({
            method: 'post',
            url: '/cards/update',
            params: {
                id: this.activeObj.id,
                card_version,
                end_date:endDate,
                pay_date: this.getCurrentDate()
            }
            })
            .then(res => {
            this.loading = false
            if (res.errno == 0) {
                this.$message.success('操作成功')
                this.upgradeDialogClose()
                this.getData()
            } else {
                this.$message.error('操作失败')
            }
            })
            .catch(err => {
            this.loading = false
            this.$message.error('操作异常')
            })
        }).catch(() => {});
    },
    // 修改状态
    onUpdateState({ row, $index }) {
      const status = row.status == '1' ? '2' : '1'
      this.$confirm(`确定要${row.status == '1' ? '停用' : '启用'} ${row.name} 的账号吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http({
          method: 'post',
          url: '/cards/update',
          params: {
            id: row.id,
            status
          }
        })
        .then(res => {
          this.loading = false
          if (res.errno == 0) {
            this.$message.success('操作成功')
            this.getData()
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('操作异常')
        })
      }).catch(() => {});
    },
    // 通过审核
    onPassReview() {
      this.$confirm(`确定要通过 ${this.activeObj.phone} 的审核吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http({
          method: 'post',
          url: '/cards/update',
          params: {
            id: this.activeObj.id,
            status: '1'
          }
        })
        .then(res => {
          this.loading = false
          if (res.errno == 0) {
            this.$message.success('操作成功')
            this.imageDialogClose()
            this.getData()
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('操作异常')
        })
      }).catch(() => {});
    },
    onUpdate(scope) {
      sessionStorage.setItem('updatePersonal', JSON.stringify(scope.row))
      this.$router.push({
        path: '/updatePersonal',
        query: {
          id: scope.row.id
        }
      })
    },
    onDelete(scope) {
      this.$confirm(`确定要删除 ${scope.row.name} 的名片吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            method: 'post',
            url: '/personal/delete',
            params: {
              id: scope.row.id
            }
          })
          .then(res => {
            if (res.errno == 0) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error('服务端异常，网点删除失败')
            }
          })
          .catch(err => {
            this.$message.error('服务端异常，网点删除失败')
          })
        }).catch(() => {});
    },
    // 关闭开通名片弹框
    opencardDialogClose() {
        this.activeObj = {}
        this.card_version = ''
        this.dialogOpencardVisible = false
    },
    // 关闭升级弹框
    upgradeDialogClose() {
        this.activeObj = {}
        this.up_type = ''
        this.upNum = 1
        this.dialogUpgradeVisible = false
    },
    // 查看图片弹框关闭
    imageDialogClose() {
      this.activeObj = {}
      this.dialogDetailVisible = false
    },
    // 删除图片
    onRemoveImage(fileName, type) {
      if (!fileName) {
        this.$message.warning('图片名称不能为空')
        return
      }
      let tip = '确定要删除图片吗？'
      if (type == 'photo') {
        tip = '确定要删除头像吗？'
      } else if (type == 'share_image') {
        tip = '确定要删除分享图吗？'
      }
      this.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            method: 'post',
            url: '/cards/remove/img',
            params: {
              fileName
            }
          })
          .then(res => {
            this.loading = false
            if (res.errno == 0) {
              this.$message.success(res.msg)
              if (type == 'photo') {
                this.onUpdateData({
                  photo: ''
                }, type)
              } else if (type == 'share_image') {
                this.onUpdateData({
                  share_image: ''
                }, type)
              }
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('操作异常')
          })
        }).catch(() => {});
    },
    // 批量删除海报
    onBatchRemoveBanner(fileName, index) {
      if (!fileName || fileName == '') {
        this.$message.warning('图片名称不能为空')
        return
      }
      this.$confirm(`确定要删除第 ${index+1} 张图片吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            method: 'post',
            url: '/cards/remove/img',
            params: {
              fileName
            }
          })
          .then(res => {
            this.loading = false
            if (res.errno == 0) {
              this.$message.success(res.msg)
              this.activeObj.bannerimg.splice(index, 1)
              this.onUpdateBanner(this.activeObj.bannerimg)
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('操作异常')
          })
        }).catch(() => {});
    },
    // 删除后更新数据
    onUpdateData(form, type) {
      if (!this.activeObj) {
        this.$message.error('数据更新异常')
        return
      }
      this.$http({
          method: 'post',
          url: '/cards/update',
          params: {
            id: this.activeObj.id,
            ...form
          }
        })
        .then(res => {
          this.loading = false
          if (res.errno == 0) {
            this.$message.success('数据已更新')
            this.$set(this.activeObj, type, '')
          } else {
            this.$message.error('数据更新失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据更新异常')
        })
    },
    // 删除海报后更新
    onUpdateBanner(data) {
      if (!this.activeObj) {
        this.$message.error('数据更新异常')
        return
      }
      this.$http({
          method: 'post',
          url: '/cards/update',
          params: {
            id: this.activeObj.id,
            bannerimg: this.activeObj.bannerimg && this.activeObj.bannerimg.length > 0 ? JSON.stringify(this.activeObj.bannerimg) : ''
          }
        })
        .then(res => {
          this.loading = false
          if (res.errno == 0) {
            this.$message.success('数据已更新')
          } else {
            this.$message.error('数据更新失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据更新异常')
        })
    },
    // 刷新详情
    getNewCardInfo() {
      this.newLoading = true
      this.$http({
          method: 'post',
          url: '/cards/findone',
          params: {
            user_no: this.activeObj.user_no
          }
        })
        .then(res => {
          this.newLoading = false
          if (res.errno == 0) {
            let item = res.data.data
            if (item.bannerimg) {
              item.bannerimg = JSON.parse(item.bannerimg)
            }
            this.activeObj = item
          } else {
            this.$message.error('刷新失败')
          }
        })
        .catch(err => {
          this.newLoading = false
          this.$message.error('网络异常，刷新失败')
        })
    },
    // 清空数据
    onClearData() {
      this.$confirm(`确定要清空当前用户的数据吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let form = {
            name: '',
            photo: '',
            job: '',
            company: '',
            weixin: '',
            qq: '',
            email: '',
            address: '',
            bgimg: '',
            bannerimg: '',
            share_image: '',
            share_title: '',
            share_desc: '',
          }
          this.$http({
            method: 'post',
            url: '/cards/update',
            params: {
              id: this.activeObj.id,
              ...form
            }
          })
          .then(res => {
            this.loading = false
            if (res.errno == 0) {
              this.$message.success('操作成功')
              this.getNewCardInfo()
              this.getData()
            } else {
              this.$message.error('操作失败')
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('操作异常')
          })
        }).catch(() => {});
    },
    // 进入待审
    onJoinReview() {
      this.$confirm(`确定将 ${this.activeObj.phone} 列入待审状态吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http({
          method: 'post',
          url: '/cards/update',
          params: {
            id: this.activeObj.id,
            status: '3'
          }
        })
        .then(res => {
          this.loading = false
          if (res.errno == 0) {
            this.$message.success('操作成功')
            this.getNewCardInfo()
            this.getData()
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('操作异常')
        })
      }).catch(() => {});
    },
    // 删除名片信息
    onRemoveCardInfo(form, type) {
      this.$confirm(`确定将该内容吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http({
          method: 'post',
          url: '/cards/update',
          params: {
            id: this.activeObj.id,
            ...form
          }
        })
        .then(res => {
          this.loading = false
          if (res.errno == 0) {
            this.$message.success('数据已更新')
            this.$set(this.activeObj, type, '')
          } else {
            this.$message.error('数据更新失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据更新异常')
        })
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: #fff;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 20px 25px;
  overflow-y: scroll;

  .page-top-tool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }
}

/* 修改滚动条样式 */
.page-container::-webkit-scrollbar {
	width: 4px;
}
.page-container::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.active-detail {
  position: relative;
  .shenpi-resuilt-img {
    position: absolute;
    width: 120px;
    top: -70px;
    right: 0px;
    opacity: 0.6;
  }

  .active-images-layout {
    display: flex;
    flex-wrap: wrap;
    .active-images-item {
      margin: 20px;
      cursor: pointer;
    }
  }
}

.active-detail-dialog {
  height: 480px;
  overflow-y: scroll;
}
.active-detail-dialog-bottom {
  margin-top: 20px;
  text-align: right;
}

/* 修改滚动条样式 */
.active-detail-dialog::-webkit-scrollbar {
	width: 4px;
}
.active-detail-dialog::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.copy-link {
  margin-left: 10px;
  color: #409EFF;
}
.copy-link:hover {
  cursor: pointer;
}
.url-style {
  text-decoration: none;
  color: #409EFF;
}
.open-card-dialog {
    padding: 10px 20px;
}
.open-card-dialog-item {
    margin-bottom: 20px;
}
.dialog-btn {
    text-align: right;
}
.filter-btns {
    text-align: right;
    margin-top: 20px;
}
.review-btns {
  text-align: right;
  margin-top: 15px;
}
</style>